import axios from 'axios'

export default {
  namespaced: true,
  state: {
    minutes: [...Array(60).keys()],
    hours: [...Array(24).keys()],
    daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    scheduledQueries: {},
    scheduledQueriesSubscriptions: [],
    scheduledQueryLoading: true,
    scheduledQuerySubscriptionLoading: true
  },

  mutations: {
    toggleScheduledQueryLoading (state: any, newStatus: boolean) {
      state.scheduledQueryLoading = newStatus
    },

    toggleScheduledQuerySubscriptionLoading (state: any, newStatus: boolean) {
      state.scheduledQuerySubscriptionLoading = newStatus
    },

    updateScheduledQueries (state: any, data: Object) {
      state.scheduledQueries = data
    },

    updateScheduledQueriesSubscriptions (state: any, data: Object) {
      state.scheduledQueriesSubscriptions = data
    }
  },

  actions: {
    onLoadScheduledQueries ({ commit }: { [type: string]: Function }, userId: number) {
      if (userId) {
        commit('toggleScheduledQueryLoading', true)
        axios.get(`${process.env.VUE_APP_API_URI}/scheduled-queries?user=${userId}`).then((queries) => {
          commit('toggleScheduledQueryLoading', false)
          queries.data ? commit('updateScheduledQueries', queries.data) : commit('updateScheduledQueries', {})
        }).catch((error) => {
          console.error(`Error fetching scheduled queries: ${error}`)
          commit('toggleScheduledQueryLoading', false)
        })
      }
    },

    async onLoadScheduledQueriesSubscriptions ({ commit }: { [type: string]: Function }, userId: number) {
      if (userId) {
        commit('toggleScheduledQuerySubscriptionLoading', true)
        try {
          const subscriptions = await axios.get(`${process.env.VUE_APP_API_URI}/scheduled-queries/subscriptions?userId=${userId}`)
          subscriptions.data ? commit('updateScheduledQueriesSubscriptions', subscriptions.data) : commit('updateScheduledQueriesSubscriptions', [])
          commit('toggleScheduledQuerySubscriptionLoading', false)
        } catch (error) {
          console.error(`Error fetching scheduled queries subscriptoins for user ${userId}: ${error}`)
          commit('toggleScheduledQuerySubscriptionLoading', false)
        }
      }
    }
  }
}
